export const userRole = {
    usr1: 1, 
    usr2: 2,
    usr3: 3
  };
  